var Acr = Acr || {};

Acr.ThreeSixtySmall = function () {
  var mainContainer = $('.acr-threesixty-small');
  var galleriesContainer = mainContainer.find('.galleries-container');
  var buttonsTabContainer = mainContainer.find('.color-selector .row.buttons');
  var buttonsColorsContainer = mainContainer.find('.color-selector');
  var buildCTAs = mainContainer.find('.build-n-price .acr-cta-btn');
  var cutline = mainContainer.find('.js-threesixty-cutline');
  var activeGallery = true;
  var btnClass = 'btn-color-select';
  var colorName = 'color-name';
  var pClass = 'previous-image';
  var currentClass = 'current-image';
  var ext = '.jpg';
  var aspectW = 16;
  var aspectH = 9;
  var defaultTotalFrames = 72;
  var isActive = 'is-active';
  var prevCur = 'acr-threesixty-small-prev-current';
  var dButtons = '.btn-display-selector';
  var lazyClass360 = 'lazy-360';
  var lazyClassPano = 'lazy-pano';

  function Gallery(gallery) {
    this.id = gallery.name.replace(/\s/g, '_');
    this.colorId = 0;
    this.name = gallery.name;
    this.type = gallery.type;
    this.framePerGallery = gallery.frames
      ? parseInt(gallery.frames, 10)
      : defaultTotalFrames;
    this.vehicles = gallery.vehicles;
    this.disclaimer = gallery.disclaimer;
    this.activeGallery = '';
    this.ldImages = 0;
    this.frames = [];
    this.galleryContainer = '';
    this.imagesContainer = '';
    this.colorsContainer = '';
    this.spinner = '';
    this.threesixtyIcon = '';
    this.selectedFrame = 0;
    this.lWinW = 0;
    this.pointerStartPosX = 0;
    this.pointerEndPosX = 0;
    this.dragging = false;
    this.ready = false;
    this.monitorStartTime = 0;
    this.monitorInt = 10;
    this.pDist = 0;
    this.sPd = 10; // Speed
    this.cFrame = 0;
    this.eFrame = 0;
    this.ticker = 0;
    this.isLoaded = false;
    var oThis = this;

    if (activeGallery) {
      activeGallery = false;
      this.activeGallery = 'is-active';
    }
    this.initialize = function () {
      this.addTabBtnChangeGallery();
      this.addColorBtnsAndDisclaimer();

      if (this.type === 'iframe') {
        this.initIframe();
      } else if (this.type === 'pano') {
        this.initPano();
      } else {
        this.initThreesixty();
      }
    };

    this.initThreesixty = function () {
      this.addThreesixtyDom();
      this.loadImage(0);
      this.attachListeners();
      this.selectGalleryListener();
    };

    this.initIframe = function () {
      this.addIframeDom();
      this.imagesContainer.attr({
        src: this.vehicles[0].baseUrl,
      });
      this.setSizes();
      this.setColorName(0);
      this.attachIntListeners();
      this.selectGalleryListener();
    };

    this.initPano = function () {
      this.addPanoDom();
      var panoUrl = galleriesContainer.data('panohtml');
      this.setSizes();
      this.setColorName(0);
      this.attachPanoListeners();
      this.selectGalleryListener();
    };

    this.attachIntListeners = function () {
      var that = this;

      this.colorsContainer.on('click', '.btn-color-select', function (e) {
        var selected = $(this).data('item');

        e.preventDefault();

        // This function doesn't exist anywhere! Commenting for now,
        // probably can be removed next time this file needs an update
        // that.updateInterior(selected);

        that.setColorName(selected);
      });

      $(window).on('resize', that.resizeHandler);
    };

    this.attachPanoListeners = function () {
      var that = this;
      this.colorsContainer.on('click', '.btn-color-select', function (e) {
        var selected = $(this).data('item');
        e.preventDefault();
        if (that.colorId !== selected) {
          window.pano.readConfigUrlAsync(that.vehicles[selected].baseUrl);

          that.setColorName(selected);
        }
      });
      $(window).on('resize', that.resizeHandler);
    };

    this.addIframeDom = function () {
      var templateIframe = '<div class="iframe360 ' + this.id + ' item '
          + this.activeGallery + ' "><iframe id="iframeSpin-' + this.id
          + '" /></div>';

      galleriesContainer.append(templateIframe);

      this.galleryContainer = galleriesContainer.find('.iframe360.'
          + this.id);
      this.imagesContainer = galleriesContainer.find('#iframeSpin-'
          + this.id);
      this.colorsContainer = buttonsColorsContainer.find('.' + this.id);
    };

    this.addPanoDom = function () {
      var that = this;
      var templateIframe = '<div class="pano360 ' + this.id + ' item ' + lazyClassPano
          + ' ' + this.activeGallery + ' "></div>';

      galleriesContainer.append(templateIframe);
      this.galleryContainer = galleriesContainer.find('.pano360.' + this.id);

      $.ajax({
        url: galleriesContainer.data('panohtml'),
        type: 'GET',
        dataType: 'html',
        xhrFields: {
          withCredentials: true,
        },
        success: function (resp) {
          that.galleryContainer.html(resp);
          window.pano.setBasePath(galleriesContainer.data('absolute-url'));
          that.initLazyLoadingPano();
        },
        error: function (xhr, ajaxOptions, thrownError) {
          console.log(xhr.status);
          console.log(xhr.responseText);
        },
      });

      this.colorsContainer = buttonsColorsContainer.find('.' + this.id);
    };

    this.selectGalleryListener = function () {
      var toggleTimeout;
      var that = this;

      buttonsTabContainer.on('click', '[data-target="' + this.id + '"]', function (event) {
        event.preventDefault();
        if (!$(this).hasClass(isActive)) {
          var target = $(this).data('target');

          clearTimeout(toggleTimeout);

          $(dButtons).removeClass(isActive);

          $(this).addClass(isActive);

          galleriesContainer.find('.item').removeClass(isActive);
          buttonsColorsContainer.find('.item').removeClass(isActive);

          galleriesContainer.find('.' + target).addClass(isActive);
          buttonsColorsContainer.find('.' + target).addClass(isActive);
          // If the pano wasn't loaded on component load is reloaded with the current selected color
          if (target.toLowerCase() === 'interior' && !that.isLoaded) {
            that.isLoaded = true;
          }

          toggleTimeout = setTimeout(function () {
            that.resizeHandler();
          }, 500);
        }
      });
    };

    this.attachListeners = function () {
      var that = this;

      this.galleryContainer.mousedown(function (event) {
        event.preventDefault();

        that.pointerStartPosX = that.getPointerEvent(event).pageX;
        that.dragging = true;
      });

      this.galleryContainer.mouseup(function (event) {
        event.preventDefault();

        that.dragging = false;
      });

      this.galleryContainer.mousemove(function (event) {
        event.preventDefault();

        that.trackPointer(event);
      });

      this.galleryContainer.on('touchstart', function (event) {
        that.pointerStartPosX = that.getPointerEvent(event).pageX;
        that.dragging = true;
      });

      this.galleryContainer.on('touchmove', function (event) {
        that.trackPointer(event);
      });

      this.galleryContainer.on('touchend', function (event) {
        event.preventDefault();

        that.dragging = false;
      });

      this.colorsContainer.on('click', '.btn-color-select', function (e) {
        var selected = $(this).data('item');

        e.preventDefault();

        that.frames = [];
        that.eFrame = 0;
        that.ldImages = 0;

        that.clearContainer();
        that.loadImage(selected);
        that.setColorName(selected);
      });

      $(window).on('resize', that.resizeHandler);
    };

    // Handling window resize event
    this.resizeHandler = function () {
      oThis.setSizes();
    };

    // Cleaning DOM elements when changing colors
    this.clearContainer = function () {
      var $current;

      this.spinner.fadeIn();

      $current = this.imagesContainer.find('li .current-image').parent('li');
      $current.addClass(prevCur);

      this.imagesContainer.find('li:not(.' + prevCur + ')').remove();
    };

    this.trackPointer = function (event) {
      var cLc;
      if (this.ready && this.dragging) {
        this.pointerEndPosX = this.getPointerEvent(event).pageX;

        if (this.monitorStartTime < new Date().getTime() - this.monitorInt) {
          this.pDist = this.pointerEndPosX - this.pointerStartPosX;
          cLc = Math.ceil((this.framePerGallery - 1) * this.sPd
            * (this.pDist / this.galleryContainer.width()));
          this.eFrame = this.cFrame + cLc;
          this.refresh();
          this.monitorStartTime = new Date().getTime();
          this.pointerStartPosX = this.getPointerEvent(event).pageX;
        }
      }
    };

    this.refresh = function () {
      this.renderFrame();
    };

    this.renderFrame = function () {
      var deft;
      var ease;

      if (this.cFrame !== this.eFrame) {
        deft = Math.ceil((this.eFrame - this.cFrame) * 0.1);
        ease = this.eFrame < this.cFrame
          ? Math.floor((this.eFrame - this.cFrame) * 0.1)
          : deft;

        this.hidePreviousFrame();
        this.cFrame += ease;
        this.showCFrame();
        this.selectedFrame = this.getCurrFrame();
      }
    };

    this.hidePreviousFrame = function () {
      this.frames[this.getCurrFrame()]
        .removeClass(currentClass)
        .addClass(pClass);
    };

    this.showCFrame = function () {
      this.frames[this.getCurrFrame()]
        .removeClass(pClass)
        .addClass(currentClass);
    };

    this.getCurrFrame = function () {
      var c = -Math.ceil(this.cFrame % this.framePerGallery);

      if (c < 0) {
        c += (this.framePerGallery - 1);
      }

      return c;
    };

    this.getPointerEvent = function (event) {
      var e = event;
      var oE = e.originalEvent;

      return oE.targetTouches ? oE.targetTouches[0] : e;
    };

    this.addThreesixtyDom = function () {
      var templateThreeixty = '<div class="threesixty ' + this.id + ' item '
          + this.activeGallery + ' "><ol class="threesixty-images ' + lazyClass360 + ' " '
          + 'id="threesixty_images"></ol><div class="spinner"><div '
          + 'class="animated-spinner"></div></div><div '
          + 'class="threesixty-icon"><svg '
          + 'viewBox="0 0 45 20"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#360-arrows"></use></svg></div></div>';

      galleriesContainer.append(templateThreeixty);

      this.galleryContainer = galleriesContainer.find('.threesixty.'
          + this.id);
      this.imagesContainer = this.galleryContainer.find('.threesixty-images');
      this.spinner = this.galleryContainer.find('.spinner');
      this.colorsContainer = buttonsColorsContainer.find('.' + this.id);
      this.threesixtyIcon = this.galleryContainer.find('.threesixty-icon');
    };

    // Adding + Loading images based on provided DATA
    this.loadImage = function (index) {
      var that;
      var li;
      var imageN;
      var image;

      if (this.vehicles[index]) {
        that = this;
        li = document.createElement('li');
        imageN = this.vehicles[index].baseUrl
            + ('0' + (this.ldImages + 1)).slice(-2) + ext;
        image = $('<img>').attr({
          'data-src': imageN,
          'data-index': that.ldImages,
          alt: this.vehicles[index].colorName,
        })
          .addClass(pClass)
          .appendTo(li);

        this.frames.push(image);
        this.imagesContainer.append(li);


        that.imageLoaded(index);

        $(image).load(function () {
          if (parseInt($(this).attr('data-index'), 10) === that.selectedFrame) {
            that.spinner.fadeOut(500);
          }
        });

      }
    };

    this.setSizes = function () {
      var containerWidth;
      var newHeight;

      if (window.innerWidth !== this.lWinW) {
        this.lWinW = window.innerWidth;
        containerWidth = galleriesContainer.width();
        newHeight = aspectH / aspectW * containerWidth;
        this.galleryContainer.height(newHeight);
      }
    };

    // Checking loaded images against total images to start 360
    this.imageLoaded = function (index) {
      var that = this;

      this.ldImages += 1;

      if (this.ldImages === this.framePerGallery) {
        this.frames[this.selectedFrame]
          .removeClass(pClass)
          .addClass(currentClass);

        this.setColorName(index);

        that.initLazyLoading360();
        that.setSizes();
        that.showThreeSixty();

      } else {
        this.loadImage(index);
      }
    };

    // Updating color name text based on selection
    this.setColorName = function (i) {
      var selectedColorConfig = this.vehicles[i];
      var configurationType = this.name.toLowerCase();

      this.colorId = i;
      this.colorsContainer.find('.' + this.id + '.' + colorName + ' .text')
        .text(selectedColorConfig.colorName);

      this.setActiveButton(i);

      // Updates the URL for the Build CTA
      if (selectedColorConfig.colorCode) {
        buildCTAs.each(function (index, item) {
          var url = $(item).attr('href');
          $(item).attr('href', Utility.updateQueryStringParameter(url, configurationType, selectedColorConfig.colorCode));
        });
      }
    };

    // Updating active color button based on selection
    this.setActiveButton = function (i) {
      this.colorsContainer.find('.' + btnClass).removeClass(isActive);
      this.colorsContainer.find('[data-item="' + i + '"]').addClass(isActive);
    };

    // Showing 360 when all is ready
    this.showThreeSixty = function () {
      var that = this;

      this.imagesContainer.fadeIn('slow', function () {
        that.imagesContainer.find('.' + prevCur).remove();
      });

      this.ready = true;
    };

    this.addTabBtnChangeGallery = function () {
      var trackingData = $('.color-selector .threesixty-tabs').attr('data-tab-tracking');
      var trackingAttribute = '';
      if (trackingData) {
        trackingAttribute = 'data-tracking="' + trackingData + '"';
      }
      var btn = '<a href="#" ' + trackingAttribute + ' class="acr-label-3 tab-button '
          + 'btn-display-selector ' + this.activeGallery + '" data-target="'
          + this.id + '">' + this.name + '</a>';

      buttonsTabContainer.append(btn);
    };

    this.addColorBtnsAndDisclaimer = function () {
      var buttons = '<div class="' + this.id + ' item color-swatches '
          + this.activeGallery + ' ">';

      buttons += '<div class="text-container">'
                    + '<div class="' + this.id + ' ' + colorName + '">'
                      + '<span class="text acr-paragraph-7"></span>'
                    + '</div>';


      if (this.disclaimer) {
        buttons += '<div class="gallery-disclaimer">'
            + '<span class="acr-paragraph-10">' + this.disclaimer + '</span> </div>';
      }

      buttons += '</div><div class="color-buttons">';

      $.each(this.vehicles, function (index) {
        buttons += '<a href="#" class="' + btnClass;
        buttons += '" title="' + this.colorName;
        buttons += '" data-name="' + this.colorName;
        buttons += '" data-item="' + index;
        buttons += '" style="' + (this.colorSwatch.indexOf('/') >= 0 ? 'background-image: url(' + this.colorSwatch + ')' : 'background-color: ' + this.colorSwatch + '') + '">';
        buttons += '<svg viewBox="0 0 200 200">';
        buttons += '<use xmlns:xlink="http://www.w3.org/1999/xlink"';
        buttons += ' xlink:href="#checkmark"></use></svg></a>';
      });

      buttons += '</div></div>';

      buttonsColorsContainer.append(buttons);
      buttonsColorsContainer.append(cutline);
    };

    this.addLazy360 = function (element) {
      var elementChildren = [].slice.call(element.querySelectorAll('img'));
      elementChildren.forEach(function (elementChild) {

        elementChild.src = elementChild.dataset.src;
      });
    };

    this.addLazyPano = function () {
      var galleries;
      var baseUrl;
      galleries = [].slice.call(document.querySelectorAll('.acr-threesixty-small'));
      baseUrl = JSON.parse(galleries[0].dataset.galleries.replace(/[']/g, '"'))[1].vehicles[0].baseUrl;

      window.pano.readConfigUrlAsync(baseUrl);
    };

    this.initLazyLoading360 = function () {
      var that = this;
      var lazyElements360 = [].slice.call(document.querySelectorAll('.threesixty-images.' + lazyClass360));
      Utility.initLazyLoadingIO(lazyElements360, this.addLazy360);
    };

    this.initLazyLoadingPano = function () {
      var that = this;
      var lazyElementsPano = [].slice.call(document.querySelectorAll('.pano360.' + lazyClassPano));
      Utility.initLazyLoadingIO(lazyElementsPano, this.addLazyPano);
    };

    this.initialize();
  }

  function init() {
    var galleries;

    if (mainContainer.length) {
      galleries = mainContainer.data('galleries');

      if (galleries && galleries.length) {
        galleries = $.parseJSON(galleries.replace(/[']/g, '"'));
        galleries.forEach(function (gallery) {
          new Gallery(gallery);
        });
      }
    }
  }
  return {
    init: init,
  };
};
